
      import Follow from './follow.vue'
      import type { App, Plugin } from 'vue'

      export const FollowPlugin: Plugin = {
        install(app: App) {
          app.component('Follow', Follow)
        },
      }
      export { Follow }
      